import { html, LitElement, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";

@customElement('app-menu-item')
export class MenuItemComponent extends LitElement {
    @property({ type: Boolean }) k_disabled: boolean = false;
    @property({ type: String }) k_gap: string = null;

    static styles = css`
    :host {
        display: block;
    }

    .menu-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: var(--menu-item-gap, 5px);
        outline: none;
        cursor: pointer;
    }

    .menu-item[disabled] {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

    render() {
        const menuStyles = {
            "--menu-item-gap": this.k_gap,
        }
        return html`
        <div class="menu-item" ?disabled=${this.k_disabled} tabindex="0" style=${styleMap(menuStyles)}>
            <slot name="icon"></slot>
            <slot name="label"></slot>
        </div>
    `;
    }
}